/*
 *
 * CustomIndicators actions
 *
 */

import {
  GET_SURVEY_TYPES_FAILED,
  GET_SURVEY_TYPES_SUCCESS,
  GET_SURVEY_TYPES_WATCHER,
  GET_SWITCH_SURVEY_TYPES_FAILED,
  GET_SWITCH_SURVEY_TYPES_SUCCESS,
  GET_SWITCH_SURVEY_TYPES_WATCHER,
} from "./constants"

export function getSwitchSurveyTypesWatcher(payload) {
  return {
    type: GET_SWITCH_SURVEY_TYPES_WATCHER,
    payload,
  }
}

export function getSwitchSurveyTypesSuccess(payload) {
  return {
    type: GET_SWITCH_SURVEY_TYPES_SUCCESS,
    payload,
  }
}

export function getSwitchSurveyTypesFailed(payload) {
  return {
    type: GET_SWITCH_SURVEY_TYPES_FAILED,
    payload,
  }
}

export function getSurveyTypesWatcher(payload) {
  return {
    type: GET_SURVEY_TYPES_WATCHER,
    payload,
  }
}

export function getSurveyTypesSuccess(payload) {
  return {
    type: GET_SURVEY_TYPES_SUCCESS,
    payload,
  }
}

export function getSurveyTypesFailed(payload) {
  return {
    type: GET_SURVEY_TYPES_FAILED,
    payload,
  }
}
